import React, { FC } from 'react';
import OrganizationsListPage from './organization-list';
import OrganizationDetailsPage from './organization-details';
import OrganizationsBackupsPage from './organization-backups/organization-backups';
import { Route, Routes } from 'react-router-dom';

const OrganizationsIndex: FC = () => {
  return (
    <Routes>
      <Route path={`/*`} element={<OrganizationsListPage />} />
      <Route path={`/backups/*`} element={<OrganizationsBackupsPage />} />
      <Route path={`/:id`} element={<OrganizationDetailsPage />} />
    </Routes>
  );
};

export default OrganizationsIndex;
